module.exports = __webpack_public_path__ + "static/Coffee2Mobile-6acd3c288ddf4b77813fec2408150e79.png";